import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'HHMM'
})
export class MinutesToHHmmPipe implements PipeTransform{
  transform(minutes: number | null | undefined): string {
    if (minutes == null) {
      return '00:00';
    }

    const h = Math.floor(minutes / 60);
    const m = minutes % 60;

    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
  }
}
